export enum DeliveryStatus {
	DELIVERED = 'delivered',
	CANCELED = 'canceled',
	ARRIVED = 'arrived',
}
